import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useKpiCardSkeletonStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalS),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
  },
  label: {
    width: '60%',
  },
  value: {
    width: '40%',
  },
  trend: {
    width: '30%',
  },
});
